// Doble Uve · tienda: filtros visuales, "solo disponibles" y orden sobre las tarjetas que pinta Liquid.
const { $, $$, bloquearScroll } = window.DBU;
const tienda = $('[data-tienda]');

if (tienda) {
  const rejilla = $('#rejilla');
  const tarjetas = $$('[data-tarjeta]', rejilla);
  const banner = $('[data-banner-tienda]', rejilla);
  const cats = (t) => (t.dataset.cats || '').split(/\s+/).filter(Boolean);
  const ORDEN = {
    // Los destacados de la tienda (metacampo) primero aunque estén agotados; después, los disponibles
    destacados: (a, b) => (('fijo' in b.dataset) - ('fijo' in a.dataset)) || (('fijo' in a.dataset) ? 0 : a.dataset.agotado - b.dataset.agotado) || (a.dataset.orden - b.dataset.orden),
    'precio-asc': (a, b) => a.dataset.precio - b.dataset.precio,
    'precio-desc': (a, b) => b.dataset.precio - a.dataset.precio,
    nombre: (a, b) => a.dataset.nombre.localeCompare(b.dataset.nombre, 'es'),
  };
  const filtros = $$('[data-filtro]').map((b) => b.dataset.filtro);
  const estado = { filtro: 'todo', orden: 'destacados', soloDisponibles: false };

  const pintar = () => {
    const visibles = tarjetas
      .filter((t) => estado.filtro === 'todo' || cats(t).includes(estado.filtro))
      .filter((t) => !estado.soloDisponibles || t.dataset.agotado === '0')
      .sort(ORDEN[estado.orden]);
    tarjetas.forEach((t) => { t.hidden = !visibles.includes(t); });
    visibles.forEach((t) => rejilla.append(t));
    // El banner va después de las 4 primeras, en "Todo" y en su filtro, con el orden por defecto
    if (banner) {
      const sitio = estado.filtro === 'todo' || estado.filtro === tienda.dataset.bannerFiltro;
      banner.hidden = !(sitio && estado.orden === 'destacados' && visibles.length > 4);
      if (!banner.hidden) visibles[3].after(banner);
    }
    $('[data-tienda-vacia]').hidden = visibles.length > 0;
    const boton = $(`[data-filtro="${estado.filtro}"]`);
    $('#resultado').textContent = `${visibles.length} ${boton?.dataset.nombrePlural || 'productos'}`;
    $('[data-ver-resultados]').textContent = `Ver ${visibles.length} ${visibles.length === 1 ? 'producto' : 'productos'}`;
    const activos = (estado.filtro !== 'todo') + estado.soloDisponibles + (estado.orden !== 'destacados');
    const marca = $('[data-filtro-activo]');
    marca.textContent = activos || '';
    marca.hidden = !activos;
    $$('[data-filtro]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.filtro === estado.filtro)));
  };

  $$('[data-n]').forEach((el) => {
    const c = el.dataset.n;
    el.textContent = c === 'todo' ? tarjetas.length : tarjetas.filter((t) => cats(t).includes(c)).length;
  });

  // Móvil: los filtros viven en una hoja que sube desde abajo
  const hoja = $('#filtros');
  const fondo = $('.filtros-fondo');
  const abrirFiltros = (abrir) => {
    hoja.classList.toggle('abierta', abrir);
    fondo.hidden = !abrir;
    bloquearScroll(abrir);
    $('[data-abrir-filtros]').setAttribute('aria-expanded', String(abrir));
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-abrir-filtros]')) return abrirFiltros(true);
    if (e.target.closest('[data-cerrar-filtros]')) return abrirFiltros(false);
    const f = e.target.closest('[data-filtro]');
    if (f) {
      estado.filtro = f.dataset.filtro;
      history.replaceState(null, '', estado.filtro === 'todo' ? location.pathname + location.search : `#${estado.filtro}`);
      return pintar();
    }
    if (e.target.closest('[data-ver-todo]')) {
      estado.filtro = 'todo';
      estado.soloDisponibles = false;
      $('#solo-disponibles').checked = false;
      pintar();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && hoja.classList.contains('abierta')) abrirFiltros(false); });
  $('#orden').addEventListener('change', (e) => { estado.orden = e.target.value; pintar(); });
  $('#solo-disponibles').addEventListener('change', (e) => { estado.soloDisponibles = e.target.checked; pintar(); });

  const desdeHash = () => {
    const h = decodeURIComponent(location.hash.slice(1));
    if (filtros.includes(h)) estado.filtro = h;
    else if (!h && filtros.includes(tienda.dataset.preseleccion)) estado.filtro = tienda.dataset.preseleccion;
    pintar();
  };
  window.addEventListener('hashchange', desdeHash);
  desdeHash();
}
